import { HomeOutlined } from "@ant-design/icons";
import type { BreadcrumbProps } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { isInternalPath } from "../InternalLink";

export type BreadcrumbItemType = NonNullable<BreadcrumbProps["items"]>[number];

/** Home crumb — client-side navigation via React Router. */
export const breadcrumbHomeItem: BreadcrumbItemType = {
  title: (
    <Link to="/">
      <HomeOutlined />
    </Link>
  ),
};

/** Static (non-link) breadcrumb segment. */
export const breadcrumbItem = (title: ReactNode): BreadcrumbItemType => ({
  title,
});

/** Breadcrumb segment that navigates in-app without a full page reload. */
export const breadcrumbLinkItem = (
  to: string,
  title: ReactNode
): BreadcrumbItemType =>
  isInternalPath(to)
    ? { title: <Link to={to}>{title}</Link> }
    : { title, href: to };
